import proyecto from "../../api/Proyecto";

// Obtener lista de proveedores
export const getProveedores = async () => {
  const res = await proyecto.get("/proveedores");
  return res.data;
};

// Obtener lista de productos
export const getProductos = async () => {
    const res = await proyecto.get("/productos/con-series");
    return res.data;
  };
// Obtener lista de unidades de medida
export const getUnidadesMedida = async () => {
  const res = await proyecto.get("/productos/unidades");
  return res.data;
};

// Insertar una nueva compra con sus detalles
export const insertarCompra = async (compra) => {
  const res = await proyecto.post("/compras", compra);
  return res.data;
};

// Reporte/listado de compras (opcional: fechaInicio, fechaFin)
export const getCompras = async ({ fechaInicio, fechaFin, limit, offset } = {}) => {
  const params = {};
  if (fechaInicio) params.fechaInicio = fechaInicio;
  if (fechaFin) params.fechaFin = fechaFin;
  if (limit != null) params.limit = limit;
  if (offset != null) params.offset = offset;

  const res = await proyecto.get("/compras", { params });
  return res.data;
};

// Obtener una compra con su detalle
export const getCompra = async (idCompra) => {
  const res = await proyecto.get(`/compras/${idCompra}`);
  return res.data;
};
